// Mantine
import { Button, Modal, NumberInput } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'

// React
import { useState } from 'react'

// API
import { useAxiosApi } from '@/hooks/useAxiosApi'

export default function ProductionOrderComplete({
    productionOrder,
    onChanged,
}) {
    // Modal
    const [openedModal, handlersModal] = useDisclosure(false)

    // Quantities used
    const [componentConsumptions, setComponentConsumptions] = useState(
        productionOrder.component.children.map((child) => {
            return {
                component_id: child.id,
                name: child.component_category.name_fr + ' — ' + child.name,
                quantity: child.pivot.quantity,
                quantity_used: 0,
            }
        })
    )

    const setComponentQuantityUsedAtIndex = (index, quantity_used) => {
        const newComponentConsumptions = [...componentConsumptions]

        newComponentConsumptions[index].quantity_used = quantity_used
        setComponentConsumptions(newComponentConsumptions)
    }

    // Quantity completed
    const [quantityCompleted, setQuantityCompleted] = useState(0)

    const onQuantityCompletedChange = (value) => {
        // Set quantity completed value
        setQuantityCompleted(value)

        // Set quantities used
        const newComponentConsumptions = [...componentConsumptions]

        newComponentConsumptions.forEach((componentConsumption) => {
            componentConsumption.quantity_used =
                componentConsumption.quantity * value
        })

        setComponentConsumptions(newComponentConsumptions)
    }

    // Save completion
    const { requestPost, loading } = useAxiosApi()

    const saveCompletion = async () => {
        const { data } = await requestPost('/production-orders/complete', {
            production_order_id: productionOrder.id,
            quantity_completed: quantityCompleted,
            component_consumptions: componentConsumptions,
        })

        await onChanged()

        onQuantityCompletedChange(0)

        handlersModal.close()
    }

    return (
        <>
            <Modal
                opened={openedModal}
                onClose={handlersModal.close}
                title="Enregistrer des montres terminées"
                size="xl"
            >
                <div className="flex flex-col gap-5">
                    <div className="flex flex-col">
                        <span className="font-medium text-xl text-center mb-5">
                            Stock à ajouter
                        </span>

                        <div>
                            <span>{productionOrder.component.name}</span>

                            <NumberInput
                                suffix=" assemblées"
                                size="xl"
                                min={0}
                                value={quantityCompleted}
                                onChange={onQuantityCompletedChange}
                            />
                        </div>
                    </div>

                    <div className="flex flex-col">
                        <span className="font-medium text-xl text-center mb-5 mt-10">
                            Stock à déduire
                        </span>

                        <div className="flex flex-col gap-3">
                            {componentConsumptions.map((child, index) => (
                                <div
                                    className="flex justify-between items-center"
                                    key={child.component_id}
                                >
                                    <div className="flex flex-col">
                                        <span>{child.name}</span>

                                        <span className="text-sm text-gray-500">
                                            {child.quantity} par tête de montre
                                        </span>
                                    </div>

                                    <div>
                                        <NumberInput
                                            min={0}
                                            value={child.quantity_used}
                                            suffix=" consommées"
                                            clampBehavior="strict"
                                            onChange={(value) =>
                                                setComponentQuantityUsedAtIndex(
                                                    index,
                                                    value
                                                )
                                            }
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <Button
                        disabled={quantityCompleted <= 0}
                        loading={loading}
                        onClick={saveCompletion}
                    >
                        Enregistrer les {quantityCompleted} montres terminées
                    </Button>
                </div>
            </Modal>

            <Button variant="light" color="dark" onClick={handlersModal.open}>
                Enregistrer des montres terminées
            </Button>
        </>
    )
}
